import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { DocumentEntity } from '@/context/store/slices/documentDataSlice';
import { setActiveBlock } from '@/context/store/slices/siteSlice';

export function useReportActiveBlock(node: DocumentEntity) {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(setActiveBlock(node));
  }, [dispatch, node]);
}
